import {block} from '../../utils/cn';

export const cnPopover = block('popover-legacy');
